import { getRemoteStrings } from 'components/HOCs/withRemoteStrings/withRemoteStrings'

export const DEFAULT_COPY = {
  400: {
    title: 'We’re sorry about this',
    message:
      'The app is having some issues fulfilling this request. Our team will get to work on resolving the issue. Please try again later.',
    primaryCta: 'OK',
  },
  408: {
    title: 'Timed out',
    message:
      'We’re sorry, but this request has exceeded the max time to process. Tap below to return to the previous screen, or try again.',
    primaryCta: 'Try again',
    secondaryCta: 'Go back',
  },
  429: {
    title: 'Limit reached',
    message:
      'We’re sorry, but you’ve reached the limit on attempted requests for this action. These limits are put in place for security purposes. Please try again later.',
    primaryCta: 'OK',
  },
  500: {
    title: 'Please try again',
    message:
      'The server is having a hard time fufilling our request. Tap below to return to the previous screen, or try again.',
    primaryCta: 'Try again',
    secondaryCta: 'Go back',
  },
  networkError: {
    title: 'We can’t connect to the internet',
    message:
      'We’re sorry, but we’re unable to get a connection. Tap below to return to the previous screen, or if you have a better signal, please try again.',
    primaryCta: 'Retry',
    secondaryCta: 'Go back',
  },
}

export const DYNAMIC_COPY = {
  400: {
    title: getRemoteStrings('400_errors_title', DEFAULT_COPY[400].title, 'errors', true),
    message: getRemoteStrings('400_errors_body', DEFAULT_COPY[400].message, 'errors', true),
    primaryCta: getRemoteStrings(
      '400_errors_primary_cta',
      DEFAULT_COPY[400].primaryCta,
      'errors',
      true,
    ),
  },
  408: {
    title: getRemoteStrings('408_errors_title', DEFAULT_COPY[408].title, 'errors', true),
    message: getRemoteStrings('408_errors_body', DEFAULT_COPY[408].message, 'errors', true),
    primaryCta: getRemoteStrings(
      '408_errors_primary_cta',
      DEFAULT_COPY[408].primaryCta,
      'errors',
      true,
    ),
    secondaryCta: getRemoteStrings(
      '408_errors_secondary_cta',
      DEFAULT_COPY[408].secondaryCta,
      'errors',
      true,
    ),
  },
  429: {
    title: getRemoteStrings('429_errors_title', DEFAULT_COPY[429].title, 'errors', true),
    message: getRemoteStrings('429_errors_body', DEFAULT_COPY[429].message, 'errors', true),
    primaryCta: getRemoteStrings(
      '429_errors_primary_cta',
      DEFAULT_COPY[429].primaryCta,
      'errors',
      true,
    ),
  },
  500: {
    message: getRemoteStrings('500_errors_body', DEFAULT_COPY[500].message, 'errors', true),
    title: getRemoteStrings('500_errors_title', DEFAULT_COPY[500].title, 'errors', true),
    primaryCta: getRemoteStrings(
      '500_errors_primary_cta',
      DEFAULT_COPY[500].primaryCta,
      'errors',
      true,
    ),
    secondaryCta: getRemoteStrings(
      '500_errors_secondary_cta',
      DEFAULT_COPY[500].secondaryCta,
      'errors',
      true,
    ),
  },
  504: {
    title: getRemoteStrings('408_errors_title', DEFAULT_COPY[408].title, 'errors', true),
    message: getRemoteStrings('408_errors_body', DEFAULT_COPY[408].message, 'errors', true),
    primaryCta: getRemoteStrings(
      '408_errors_primary_cta',
      DEFAULT_COPY[408].primaryCta,
      'errors',
      true,
    ),
    secondaryCta: getRemoteStrings(
      '408_errors_secondary_cta',
      DEFAULT_COPY[408].secondaryCta,
      'errors',
      true,
    ),
  },
  networkError: {
    title: getRemoteStrings('network_error_title', DEFAULT_COPY.networkError.title, 'errors', true),
    message: getRemoteStrings(
      'network_error_body',
      DEFAULT_COPY.networkError.message,
      'errors',
      true,
    ),
    primaryCta: getRemoteStrings(
      'network_error_primary_cta',
      DEFAULT_COPY.networkError.primaryCta,
      'errors',
      true,
    ),
    secondaryCta: getRemoteStrings(
      'network_error_secondary_cta',
      DEFAULT_COPY.networkError.secondaryCta,
      'errors',
      true,
    ),
  },
}
